module.exports = __webpack_public_path__ + "static/img/logo.3189a7a6.svg";